import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { ProjectAlert } from 'projects/app-misc/src/app/modules/alert/data/alert';
import { AlertService } from 'projects/app-misc/src/app/modules/alert/data/alert.service';
import * as moment from 'moment';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

@Component({
    selector: 'app-alerts-list',
    templateUrl: './alerts-list.component.html',
    styleUrls: ['./alerts-list.component.scss']
})
@RxJSUnsubscribe
export class AlertsListComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    start = 0;
    limit = 12;

    alertsMap = new Map<string, ProjectAlert[]>();

    today: string;

  wsSub: Subscription;
    constructor(
        protected projectService: ProjectService,
        protected alertService: AlertService,
        protected wsService: WsService
    ) { }

    ngOnInit() {
        this.today = moment().format('L')
        this.getAlerts();
        this.wsSubToAlerts();

    }

    getAlerts() {
        this.alertService.getActiveAlerts().subscribe(alerts => {
            if (alerts.content.length > 0) {
                alerts.content.forEach(alert => {
                    const key = moment(alert.createdTime).format('L')
                    if (!this.alertsMap.has(key)) {
                        this.alertsMap.set(key, [])
                    }
                    this.alertsMap.get(key).push(alert)
                })
            }
        })
    }

    wsSubToAlerts() {
    this.wsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<ProjectAlert>>('/topic/update/model.notification.alert.ProjectAlert', this)
            .pipe(
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                this.getAlerts();
            })
    }


    returnZero() {
        return 0
    }

    ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

}
